import React from "react";
import styles from "./PoweredBy.module.scss";
import { default as AppIcon } from "../../assets/images/iconlogo.png";
// import { default as AppIcon } from "../../assets/images/applogo.png";
import { ReactComponent as LockIon } from "../../assets/images/lock.svg";
import { useSelector } from "react-redux";

type PoweredByProps = {
  device?: string;
};

const PoweredBy = ({ device = "laptop" }: PoweredByProps) => {

  const { orderDetails } = useSelector((state) => state.orderDetailsReducer);
  const supportEmail =  orderDetails?.data?.subsidiary?.supportEmail

  return (
    <div key={Math.random() * 1000} className={styles["poweredByContainer" + device]}>
      {supportEmail && (
        <div style={{width:'100%', display:'flex'}}>
          <a className={styles.supportText} href={`mailto:${supportEmail}`}> For support, kindly reach out to {supportEmail} </a>
        </div>
      )}
      <div className={styles.poweredByLogo}>
        <LockIon /> Powered by
        <img src={AppIcon} className={styles.appLogo} />
        {/* <AppIcon key={Math.random() * 1000} className={styles.appLogo} /> */}
      </div>
    </div>
  );
};

export default PoweredBy;
